import { RouteLoadingShell } from "@/components/portal/route-loading-shell";

export default function AdvancedAgentLoading() {
  return <RouteLoadingShell variant="chat" />;
}
